import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import { Strings } from "../../resources/i18n/i18n";
import { loanApplicationFormInputs } from "../CreateLoan/CreateLoanConstants";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
class FinancialInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            financialInformation: {
                numberOfEmployees: this.props.expenses?.numberOfEmployees,
                salaryOfEmployees: this.props.expenses?.salaryOfEmployees,
                rent: this.props.expenses?.rent,
                electricity: this.props.expenses?.electricity,
                telephone: this.props.expenses?.telephone,
                internet: this.props.expenses?.internet,
                gas: this.props.expenses?.gas,
                water: this.props.expenses?.water,
                debtsToSuppliers: this.props.expenses?.debtsToSuppliers,
            },
            income: {
                monthlySalesAmount: this.props.income?.monthlySalesAmount,
                accountsPending: this.props.income?.accountsPending,
                inventory: this.props.income?.inventory,
            },
            errorFieldArray: [],
            errorMessage: "",
            invalidFormField: []
        }
    }
    componentDidMount() {
        const { invalidFormField } = this.props;
        const { financialInformation, income } = this.state;

        if (Array.isArray(invalidFormField) && invalidFormField.length > 0) {
            const getFields = (type) =>
                invalidFormField.find(field => field.ft === type)?.ff || [];

            const expensesFields = getFields("EXPENSES");
            const incomeFields = getFields("INCOME");
            const finalInvalidFormField = [...expensesFields, ...incomeFields];


            finalInvalidFormField.forEach(field => {
                if (field in financialInformation) {
                    financialInformation[field] = null;
                }
            });

            finalInvalidFormField.forEach(field => {
                if (field in income) {
                    income[field] = null;
                }
            });

            this.setState({
                financialInformation: financialInformation,
                income: income,
                invalidFormField: finalInvalidFormField,
                errorFieldArray: finalInvalidFormField,
                errorMessage: finalInvalidFormField.length > 0 ? Strings("pleaseSelectRequiredFields") : ""
            });
        }
        this.props.scrollToTop();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.errorMessage !== this.props.errorMessage) {
            this.setState({ errorMessage: this.props.errorMessage });
        }
    }
    handleChange = (e, section) => {
        const { name, value } = e.target;
        this.setState(prevState => {
            const errorFieldArray = prevState.errorFieldArray?.filter(field => field !== name) || [];
            let invalidFormField = prevState.invalidFormField?.filter(field => field !== name) || [];
            let errorMessage = errorFieldArray.length === 0 ? "" : prevState.errorMessage;
            let updatedErrorFieldArray = [...errorFieldArray, ...invalidFormField];
            if (updatedErrorFieldArray.length === 0) {
                errorMessage = "";
            }
            return {
                errorFieldArray: updatedErrorFieldArray,
                invalidFormField,
                errorMessage,
                [section]: {
                    ...prevState[section],
                    [name]: value
                }
            };
        });
    };


    renderSelectionDropDown = (prop, dropDownLists, section) => {
        let errorClass = this.state.errorFieldArray?.includes(prop.key)
            ? " error-data"
            : "";
        const matchedDropdown = dropDownLists?.find(item => item.nm === prop.key);
        const dropDownList = matchedDropdown?.opt || [];

        return (
            <div className={`textFieldComponent ${errorClass}`}>
            <TextFieldComponent
                title=""
                id={prop.name}
                type={prop.type}
                className="noMargin"
                placeholder={prop.title}
                handleChange={(e) => this.handleChange(e, section)}
                value={this.state[section][prop.key] || ""}
                multiple={false}
                halfWidth={false}
                disabled={prop.disabled || this.props.disableTextField}
                name={prop.key}

            >
                {prop.isSelection && (
                    <>
                        <option value="">{Strings("select")}</option>
                        {dropDownList.map((version) => (
                            <option
                                key={
                                    version.value ||
                                    version.label ||
                                    version.name ||
                                    version.key ||
                                    version.pstid ||
                                    version
                                }
                                value={
                                    version.value ||
                                    version.label ||
                                    version.id ||
                                    version.pstid ||
                                    version.name ||
                                    version
                                }
                                disabled={
                                    this.props.ZONE_POSITION && version.pstid === prop.value
                                }
                            >
                                {version.label ||
                                    version.name ||
                                    version.pstn ||
                                    Strings(version)}
                            </option>
                        ))}
                    </>
                )}
            </TextFieldComponent>
            </div>
        );
    };
    renderIncome = (editableData, dropDownLists) => {
        const isPersonalLoan = this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN;
        return (
            <Row className='subHeaderApplication addOrUpdateUserFontSize ps-3'>
                {editableData.map((prop) => {
                    const displayName = (isPersonalLoan && prop.personalLoanName) ? prop.personalLoanName : prop.name;
                    let renderTextField;
                    if (prop.isSelection) {
                        renderTextField = this.renderSelectionDropDown(prop, dropDownLists, "income");
                    }
                    return (
                        <Col
                            key={prop.name}
                            md={{ span: prop.md ? prop.md : 4 }}
                            className='ps-0 pe-3'
                        >
                            <Row>
                                <Col md={11}>
                                    <Row>
                                        <Col md={{ span: 12 }} className='px-0 pt-3'>
                                            <span className={prop.className ? prop.className : ""}>{displayName}</span>
                                            {prop.isMandatory && (
                                                <span className='mandatoryFields'>*</span>
                                            )}
                                        </Col>
                                        <Col
                                            md={{ span: 12 }}
                                            className={
                                                prop.name === "aid"
                                                    ? "px-0 pt-4 textFieldComponent fullWidth"
                                                    : "px-0 pt-2 textFieldComponent fullWidth"
                                            }
                                        >
                                            {renderTextField}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    );
                })}
            </Row>
        );
    };
    renderFinancialInformation = (editableData, dropDownLists) => {
        return (
            <Row className='subHeaderApplication addOrUpdateUserFontSize ps-3'>
                {editableData.map((prop) => {
                    let renderTextField;
                    if (prop.isSelection) {
                        renderTextField = this.renderSelectionDropDown(prop, dropDownLists, "financialInformation");
                    }
                    return (
                        <Col
                            key={prop.name}
                            md={{ span: prop.md ? prop.md : 4 }}
                            className='ps-0 pe-3'
                        >
                            <Row>
                                <Col md={11}>
                                    <Row>
                                        <Col md={{ span: 12 }} className='px-0 pt-3'>
                                            <span className={prop.className ? prop.className : ""}>{Strings(prop.name)}</span>
                                            {prop.isMandatory && (
                                                <span className='mandatoryFields'>*</span>
                                            )}
                                        </Col>
                                        <Col
                                            md={{ span: 12 }}
                                            className={
                                                prop.name === "aid" ? "px-0 pt-4 textFieldComponent fullWidth" : "px-0 pt-2 textFieldComponent fullWidth"
                                            }
                                        >
                                            {renderTextField}
                                        </Col>
                                    </Row>

                                </Col>

                            </Row>
                        </Col>
                    );
                })}
            </Row>
        );
    };
    validateData = () => {
        if (this.props.disableTextField) {
            this.props.goNext();
            return;
        }
        const errorFieldArray = [];
        Object.entries(this.state.financialInformation).forEach(([key, value]) => {
            if (!value) {
                errorFieldArray.push(key);
            }
        });

        Object.entries(this.state.income).forEach(([key, value]) => {
            if (!value) {
                errorFieldArray.push(key);
            }
        });
        let finalErrorFieldArray = [...errorFieldArray, ...this.state.invalidFormField];
        if (finalErrorFieldArray.length === 0) {
            let requestData = {
                ...this.state.financialInformation,
                ...this.state.income
            }
            this.props.setIncomeDataAction(this.state.income)
            this.props.setFinancialInformationAction(this.state.financialInformation)

            this.props.callAPI(requestData, (errorMessage) => {
                this.setState({ errorMessage: errorMessage });
            })
        }
        this.setState({
            errorFieldArray,
            errorMessage: errorFieldArray.length > 0 ? Strings("pleaseSelectRequiredFields") : ""
        });
    };
    renderButtons = () => {
        return (
            <Row className='modalButton justify-content-between ps-3'>
                <Col md={2} className='text-start'>
                    <Button
                        className='buttonBorder'
                        onClick={this.props.goBack}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>

                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goNext}
                        disabled={(!this.props.expenses?.prefillData) || this.props.showLoadingModalState}
                    >
                        {Strings("Next").toUpperCase()}
                    </Button>
                    {!this.props.disableTextField && <Button
                        className={
                            "buttonBackground"
                        }
                        onClick={this.validateData}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("saveAndProceed")}
                    </Button>}
                </Col>
            </Row>
        )
    }
    renderErrors = () => {
        return (
            <Col
                md={12}
                className='errors ps-4 mb-0 ms-1'
            >
                {this.state.errorMessage}
            </Col>
        )
    }
    render() {
        return (
            <Col md={12}>
                {this.renderErrors()}
                {this.renderIncome(loanApplicationFormInputs.financialInformation, this.props.financialInfoList)}
                <hr className="opacity-100 mb-2 mt-4 ms-2 me-2" />
                <Row className="ps-3 pt-2">
                    <span className="createLoanSubHeadingText">
                        {Strings("Expenses")}
                    </span>
                </Row>
                {this.renderFinancialInformation(loanApplicationFormInputs.expenses, this.props.expensesLists)}
                <hr className="opacity-100 mb-2 mt-4 ms-2 me-2" />
                {this.renderButtons()}

            </Col>
        )
    }
}
export default FinancialInformation;